import { Placement } from "react-bootstrap/esm/types";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { ClickableIcon } from "../clickable-icon/clickable-icon";
import { IdwFormLabel } from "../idw-form-label/idw-form-label";
import styles from "./idw-form-label-with-icon-container.less";

type IdwFormLabelWithIconContainerProps = {
    labelWidth: LabelWidthTypes;
    layout: LayoutTypes;
    label: string;
    isRequired: boolean;
    afterLabelTooltipText?: string;
    afterLabelTooltipTextPosition?: Placement;
    afterLabelIconDisabled?: boolean;
    afterLabelIcon?: IconDefinition;
    afterLabelIconOnClick?: () => void;
    rightAlignedLabelElement?: React.ReactNode;
    controlId: string;
};

export const IdwFormLabelWithIconContainer = (props: IdwFormLabelWithIconContainerProps) => {
    const {
        labelWidth,
        layout,
        label,
        isRequired,
        afterLabelTooltipText,
        afterLabelTooltipTextPosition,
        afterLabelIcon,
        afterLabelIconDisabled,
        afterLabelIconOnClick,
        rightAlignedLabelElement,
        controlId
    } = props;

    return (
        <div className={styles.idwFormLabelWithIconContainer}>
            <IdwFormLabel
                isRequired={isRequired}
                labelWidth={labelWidth}
                layout={layout}
                label={label}
                tooltipText={afterLabelTooltipText}
                tooltipTextPosition={afterLabelTooltipTextPosition}
            />
            {afterLabelIcon && afterLabelIconOnClick && (
                <div>
                    <ClickableIcon controlId={controlId} disabled={afterLabelIconDisabled} icon={afterLabelIcon} onClick={afterLabelIconOnClick} className={styles.afterLabelIcon} />
                </div>
            )}
            {rightAlignedLabelElement ? (
                rightAlignedLabelElement
            ) : null}
        </div>
    );
};